import React, { useContext } from 'react';
import {
  MedioInline as MedioInlineComponent
} from '@thd-olt-component-react/internal-marketing-banner';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import proptypes from 'prop-types';
import { HomepageContext } from './context/HomepageContext';

const { string } = proptypes;

export function MedioInline({ id }) {
  const { isB2C } = useContext(HomepageContext);

  return (
    <ErrorBoundary name="internal-marketing-banner-medio-inline">
      <QueryProvider key={id} cacheKey={id}>
        <MedioInlineComponent componentId={id} componentClass="MedioInline" enableB2CRadius={isB2C} />
      </QueryProvider>
    </ErrorBoundary>
  );
}

MedioInline.propTypes = {
  id: string.isRequired
};

MedioInline.defaultProps = {};
